// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jtZ-","delete":"styles_delete__2YUUi","update":"styles_update__2Dku2","add":"styles_add__2yA81"};